import { StyledTable } from "../../../styles/StyledUnit/StyledContent";
import { PropTypes } from "prop-types";
import DeleteIcon from "../../../assets/img/icons/delete.svg";
import CloseIcon from "../../../assets/img/icons/close.svg";
import SaveIcon from "../../../assets/img/icons/save.svg";
import EditIcon from "../../../assets/img/icons/edit-black.svg";
import { addMatter, editMatter, getMattersList, reorderMatters } from "../../../api/unit/matters";
import { useState, useEffect } from "react";
import { useUnitContext } from "../../../context/unitContext";
import useAxiosPrivate from "../../../hooks/useAxiosPrivate";
import OrderSelect from "../../OrderSelect/OrderSelect";
import { StyledQuestionInput, StyledDecisionTableRow } from "../../../styles/StyledUnit/StyledDecisionTable";

export default function UnitMatter({ refetch, data, edit, setAddNew, openModal, setDeletedId, index, total, editingId, setEditingId, unitId }) {
  const { axiosPrivate } = useAxiosPrivate();
  const [isEdit, setIsEdit] = useState(edit);
  const [matterName, setMatterName] = useState(data.name || "");
  const [order, setOrder] = useState(typeof index === "number" ? index + 1 : 1);
  const isLocked = editingId !== null && editingId !== data.id;

  useEffect(() => {
    if (isEdit) {
      setMatterName(data.name || "");
      setOrder(typeof index === "number" ? index + 1 : 1);
    }
  }, [isEdit, data.name, index]);

  const handleChange = (e) => setMatterName(e.target.value);

  const handleEdit = async () => {
	const updatedName = matterName.trim();
	const hasNameChanged = updatedName !== data.name;
	const hasOrderChanged = order !== data.order;
	if (edit) {
		await addMatter(axiosPrivate, refetch, { organizationUnit: unitId, name: updatedName, order: order });
	} else if (hasNameChanged) {
		await editMatter(axiosPrivate, refetch, data.id, { name: updatedName });
	}
	if (hasOrderChanged) {
		try {
			const res = await getMattersList(axiosPrivate, unitId, null);
			const reordered = res
				.filter((m) => m.id !== data.id)
				.sort((a, b) => a.order - b.order);

			reordered.splice(order - 1, 0, { ...data, order });
			const payload = reordered.map((item, idx) => ({
				id: item.id,
				order: idx + 1,
			}));

			await reorderMatters(axiosPrivate, payload);
		} catch (err) {
			console.error("Order update failed:", err);
		}
	}
	setIsEdit(false);
	setEditingId(null);
	if (setAddNew) setAddNew(false);
	refetch();
  };


  return (
    <StyledDecisionTableRow>
      {isEdit ? (
        <OrderSelect value={order} total={data.id ? total : total + 1} onChange={setOrder} />
      ) : (
        <span>{index + 1}</span>
      )}
      {isEdit ? (
        <StyledQuestionInput type="text" name="name" value={matterName} onChange={handleChange} />
      ) : (
        <span>{data.name}</span>
      )}
      <div>
        {isEdit ? (
          <>
            <img onClick={handleEdit} src={SaveIcon} alt="Save" role="img" />
            <img
              onClick={() => {
                setIsEdit(false);
                setEditingId(null);
                if (setAddNew) setAddNew(false);
              }}
              src={CloseIcon}
              alt="Cancel"
              role="img"
            />
          </>
        ) : (
          <>
            <img
              onClick={() => {
                if (!isLocked) {
                  setIsEdit(true);
                  setEditingId(data.id);
                }
              }}
              src={EditIcon}
              alt="Edit"
              role="img"
              style={{ opacity: isLocked ? 0.3 : 1, pointerEvents: isLocked ? "none" : "auto" }}
            />
            <img
              onClick={() => {
                if (!isLocked && openModal) {
                  setDeletedId(data.id);
                  openModal();
                }
              }}
              src={DeleteIcon}
              alt="Delete"
              role="img"
              style={{ opacity: isLocked ? 0.3 : 1, pointerEvents: isLocked ? "none" : "auto" }}
            />
          </>
        )}
      </div>
    </StyledDecisionTableRow>
  );
}

UnitMatter.propTypes = {
  data: PropTypes.object,
  edit: PropTypes.bool,
  index: PropTypes.number,
  total: PropTypes.number,
  unitId: PropTypes.number,
  setAddNew: PropTypes.oneOfType([PropTypes.func, PropTypes.bool]),
  refetch: PropTypes.oneOfType([PropTypes.func, PropTypes.bool]),
  openModal: PropTypes.oneOfType([PropTypes.func, PropTypes.bool]),
  setDeletedId: PropTypes.oneOfType([PropTypes.func, PropTypes.bool]),
  editingId: PropTypes.oneOfType([PropTypes.number, PropTypes.oneOf([null])]),
  setEditingId: PropTypes.func,
};

UnitMatter.defaultProps = {
	edit: false,
	setAddNew: false,
	refetch: false,
	openModal: false,
	setDeletedId: false,
};
